// src/theme.js
import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    // 94% white, not pure white: ~12:1 contrast on a near-black panel without the glare
    text: {
      primary: '#e6eaf2',
      secondary: '#a8b4cc',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Noto Sans", "DejaVu Sans", sans-serif',
  },
});

// Kiosk-specific theme that builds on top of darkTheme
export const kioskTheme = createTheme(darkTheme, {
  palette: {
    background: {
      default: '#010101',
      paper: '#17131F',
    },
    primary: {
      main: '#FFC727',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#C7C2D2',
    },
  },
  shape: {
    borderRadius: 18,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 999,
          fontWeight: 600,
        },
        // backgroundImage, not background: the palette colour stays underneath,
        contained: {
          backgroundImage:
            'linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0.02))',
          boxShadow: '0 6px 16px rgba(0,0,0,0.30)',
          border: '1px solid rgba(255,255,255,0.10)',
          transition: 'transform 80ms ease, box-shadow 80ms ease',
          '&:hover': {
            backgroundImage:
              'linear-gradient(180deg, rgba(255,255,255,0.26), rgba(255,255,255,0.06))',
            boxShadow: '0 10px 22px rgba(0,0,0,0.38)',
            transform: 'translateY(-2px)',
          },
          '&:active': {
            transform: 'translateY(0)',
            boxShadow: '0 4px 10px rgba(0,0,0,0.30)',
          },
          // A lit disabled button reads as available
          '&.Mui-disabled': {
            backgroundImage: 'none',
            boxShadow: 'none',
            transform: 'none',
          },
        },
        // Outlined is a hairline on a dark panel; give it body, keep its colour
        outlined: {
          backgroundColor: 'rgba(255,255,255,0.05)',
          backgroundImage:
            'linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.01))',
          borderWidth: '2px',
          '&:hover': {
            backgroundImage:
              'linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0.04))',
            borderWidth: '2px',
          },
          '&.Mui-disabled': { backgroundImage: 'none', borderWidth: '2px' },
        },
      },
    },
  },
});
